import type { ComponentProps } from "react"
import { DevTool as HookFormDevTool } from "@hookform/devtools"

/** React Hook Form's debug panel, shown on the dev server only. */
export const DevTool = (props: ComponentProps<typeof HookFormDevTool>) =>
  import.meta.env.DEV ? <HookFormDevTool {...props} /> : null
